<template>
  <div class="payPage">
    <LinkTitle></LinkTitle>

    <div class="payPageBox">
      <PageSearchTitle :hideCart="true" :hideSearch="true" title="收银台" />
      <div class="orderInfo">
        <div class="orderInfoUp">
          <div>
            订单提交成功，请尽快付款！订单号：{{ $route.query.order_id }}
          </div>
          <div>
            应付金额
            <span class="totalMoney">{{
              Number($route.query.totalMoney).toFixed(2)
            }}</span
            >元
          </div>
        </div>
        <div class="orderInfoDown">
          <div>请您在24小时内完成支付，否则订单会被自动取消</div>
          <div>收款方:{{ $route.query.store_name }}</div>
        </div>
      </div>
      <div class="pay">
        <div class="payTitle">支付方式</div>
        <div class>
          <div class="yhkBox">
            <div class="yhk">
              <el-radio
                v-model="payType"
                size="small"
                @change="payTypeChange"
                border
                label="1"
              >
                <span>银行卡快捷支付</span>
              </el-radio>
            </div>
          </div>
          <div class="yhkBox">
            <div class="yhk">
              <el-radio
                v-model="payType"
                @change="payTypeChange"
                size="small"
                border
                label="6"
              >
                <span>微信支付</span>
              </el-radio>
            </div>
          </div>

          <div class="yhkBox">
            <div class="yhk">
              <el-radio
                v-model="payType"
                @change="payTypeChange"
                size="small"
                border
                label="2"
              >
                <span>网上银行支付</span>
              </el-radio>
            </div>
          </div>
          <div
            v-if="
              userInfo.storeId &&
              $route.query.type != 10 &&
              $route.query.type != 12
            "
            class="yhkBox"
          >
            <div class="yhk">
              <el-radio
                v-model="payType"
                @change="payTypeChange"
                size="small"
                border
                label="4"
              >
                <span>钱包余额支付</span>
              </el-radio>
              <span>可用余额: {{ storeWalletBalance }}元</span>
            </div>
          </div>
          <!-- 只要不是预付款充值订单都可以使用预付款支付 -->
          <div
            v-if="
              $route.query.type != 10 &&
              $route.query.type != 12 &&
              $route.query.type != 9
            "
            class="yhkBox"
          >
            <div class="yhk">
              <el-radio
                v-model="payType"
                @change="payTypeChange"
                size="small"
                border
                label="5"
              >
                <span>预付款支付&nbsp;&nbsp;&nbsp;</span>
              </el-radio>
              <span>可用余额: {{ prepayBalance }}元</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 银行卡快捷支付 -->
      <div v-if="payType == 1">
        <div class="payTitle">快捷银行</div>
        <div
          v-for="(item, index) in bankList"
          @click="() => selectBank(item, index)"
          :key="index + 'bankList'"
          :class="['yhkNum', item.checked ? 'checked' : '']"
        >
          <el-radio v-model="bank.gate_id" :label="item.gate_id">
            <span></span>
          </el-radio>
          <span class="yhkNumBankName">{{ item.gate_id }}</span>
          <span class="yhkNumName">{{ item.bank_account_name }}</span>
          <span>{{ `储蓄卡(${item.bank_account})` }}</span>
        </div>
        <div class="addNewCard">
          <el-button type="danger" @click="addPayCard" size="mini"
            >+ 绑定银行卡并支付</el-button
          >
        </div>
        <!-- <div class="yhkMore">更多</div> -->
        <div v-if="bankList && bankList.length">
          <div class="phoneNumber">关联手机号：{{ phoneNumber }}</div>
          <div class="sendMsgBox">
            <div class="sendMsgBoxInput">
              <el-input
                v-model="code"
                size="small"
                placeholder="输入验证码"
              ></el-input>
            </div>
            <el-button
              @click="sendPayMessage"
              size="small"
              :loading="sendButtonLoading"
              :disabled="sendMsgDisabled"
              type="danger"
              :style="{ borderRadius: 0 }"
              >{{ msg }}</el-button
            >
          </div>
          <div class="recharge">
            <el-button
              @click="recharge"
              :style="{ width: '170px' }"
              type="danger"
              >{{ payMsg }}</el-button
            >
          </div>
        </div>
      </div>

      <!-- 网银支付 -->
      <div v-if="payType == 2">
        <div class="payTitle">网银支付</div>
        <EBankRechart :id="$route.query.id" />
      </div>

      <!-- 钱包余额支付 -->
      <div
        v-if="
          payType == 4 && $route.query.type != 10 && $route.query.type != 12
        "
      >
        <div class="payTitle">
          钱包余额支付
          <span
            v-if="storeWalletBalance < $route.query.totalMoney"
            class="lackTips"
            >(余额不足)</span
          >
        </div>
        <div v-loading="storeWallateLoading">
          <div v-if="!existStoreWallatePsw">
            该店铺尚未设置店铺钱包余额支付密码,请先设置支付密码
            <div class="setPwdBox">
              <el-button
                @click="setPwd"
                size="small"
                type="danger"
                :style="{ borderRadius: 0 }"
                >设置支付密码</el-button
              >
            </div>
          </div>
          <div class="inputPswBox" v-else>
            <div class="inputPsw">请输入6位支付密码&nbsp;:</div>
            <div class="sendMsgBox">
              <div class="wallatBalanceBoxInput">
                <el-input
                  v-model="StoreWalletPsw"
                  size="small"
                  @focus="wallatePayTips.show = false"
                  autocomplete="new-password"
                  type="passWord"
                  :maxlength="6"
                  @input="passwardChanage"
                  placeholder="输入密码"
                ></el-input>
              </div>
              <span v-if="wallatePayTips.show" class="wallatePayTips">{{
                wallatePayTips.value
              }}</span>
              <!-- <el-button
              @click="payByStoreWallet"
              size="small"
              :loading="sendButtonLoading"
              :disabled="sendMsgDisabled"
              type="danger"
              :style="{borderRadius:0}"
              >确认支付</el-button> -->
            </div>
          </div>
        </div>
      </div>

      <!-- 预付款余额支付 -->
      <div
        v-if="
          payType == 5 &&
          $route.query.type != 10 &&
          $route.query.type != 12 &&
          $route.query.type != 9
        "
      >
        <div class="payTitle">
          预付款支付
          <span v-if="prepayBalance < $route.query.totalMoney" class="lackTips"
            >(余额不足)</span
          >
        </div>
        <div v-loading="storeWallateLoading">
          <div v-if="!existStoreWallatePsw">
            该店铺尚未设置预付款支付密码,请先设置支付密码
            <div class="setPwdBox">
              <el-button
                @click="setPwd"
                size="small"
                type="danger"
                :style="{ borderRadius: 0 }"
                >设置支付密码</el-button
              >
            </div>
          </div>
          <div class="inputPswBox" v-else>
            <div class="inputPsw">请输入6位支付密码&nbsp;:</div>
            <div class="sendMsgBox">
              <div class="wallatBalanceBoxInput">
                <el-input
                  v-model="StoreWalletPsw"
                  size="small"
                  @focus="wallatePayTips.show = false"
                  autocomplete="new-password"
                  type="passWord"
                  :maxlength="6"
                  @input="passwardChanage"
                  placeholder="输入密码"
                ></el-input>
              </div>
              <span v-if="wallatePayTips.show" class="wallatePayTips">{{
                wallatePayTips.value
              }}</span>
              <!-- <el-button
              @click="payByStoreWallet"
              size="small"
              :loading="sendButtonLoading"
              :disabled="sendMsgDisabled"
              type="danger"
              :style="{borderRadius:0}"
              >确认支付</el-button> -->
            </div>
          </div>
        </div>
      </div>

      <!-- 微信扫码支付 -->
      <div v-if="payType == 6">
        <div class="payTitle">微信支付</div>
        <div>
          <div :style="{ color: '#666', fontSize: '14px' }">
            <span :style="{ position: 'relative', top: '-2px' }">① </span
            >使用手机微信扫描二维码并支付
          </div>
          <div :style="{ color: '#666', fontSize: '14px' }">
            <span :style="{ position: 'relative', top: '-2px' }">② </span
            >支付成功后请点击下方链接跳转刷新订单
          </div>
          <el-image
            style="width: 200px; height: 200px"
            :src="QRCodeUrl"
            fit="contain"
          ></el-image>
        </div>
        <a class="wxGoback" @click="goback"> 微信已付款，返回并刷新订单 </a>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import PageSearchTitle from "./components/PageSearchTitle";
import EBankRechart from "./components/EBankRechart";
import {
  listBankCardUrl,
  sendPayVerifyCodeUrl,
  confirmPayVerifyUrl,
  getStoreAccountUrl,
  payOrderUrl,
  balancePayUrl,
  storeBanList,
  getCust,
  createOderCode,
  baseUrl,
} from "@/api/api";

export default {
  data() {
    return {
      payType: "1",
      bankList: null,
      bank: null,
      code: "",
      msg: "验证码",
      time: 60,
      sendMsgDisabled: false,
      sendButtonLoading: false,
      payMsg: "确认付款",
      waitingTime: 3, //支付成功等待时间
      storeWalletBalance: 0,
      prepayBalance: 0,
      StoreWalletPsw: "",
      storeWallateLoading: false,
      wallatePayTips: {
        show: false,
        value: "",
      },
      existStoreWallatePsw: true,
      QRCodeUrl: "",
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    phoneNumber() {
      if (this.bank) {
        let phoneNumber = this.bank.mobile_id;
        phoneNumber =
          phoneNumber.substr(0, 3) +
          "****" +
          phoneNumber.substr(phoneNumber.length - 4, 4);
        return phoneNumber;
      }
    },
  },
  watch: {
    $route() {},
  },
  created() {
    this.getBankList();
    this.checkAndGetStoreBanlance();
    this.checkAndGetPrepayBalance();
  },
  components: {
    PageSearchTitle,
    EBankRechart,
  },
  methods: {
    ...mapMutations([]),
    setPwd() {
      this.$router.push({name:"settingPage",query:{type:"settingPwd"}})
    },
    goback() {
      this.$router.go(-1);
    },
    addPayCard() {
      this.$router.push({
        name: "addPayCard",
        query: { ...this.$route.query },
      });
    },
    setPayflag() {
      //货到付款权限判断

      // .then(userInfo => {

      //   let { access_token, storeId } = userInfo
      //   if (!storeId) {
      //     const url = getCust
      //     return global.network.post(url, { access_token, store_id: this.props.orders[0].store_id })
      //   } else {
      //     return Promise.resolve({ resultCode: 1, data: { pay_flag: false } })
      //   }
      // })
      // .then((res) => {
      //   if (res.resultCode === 1) {
      //     this.setState({ pay_flag: res.data ? res.data.pay_flag : false })
      //     return Promise.resolve(1)
      //   } else {
      //     Toast.fail(res.resultMsg || '未知错误', 2)
      //   }
      // })
      // .catch(this.onError)

      let { access_token, storeId } = userInfo;
    },
    checkAndGetPrepayBalance() {
      if (this.$route.query.type != 9) {
        //只要不是预付款充值订单就可以用预付款方式支付
        let { access_token, storeId } = this.userInfo;

        let url = storeId ? storeBanList : getCust;
        let data = {
          access_token: access_token,
          store_id: this.$route.query.store_id, //卖家店铺store_id
        };
        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        this.$axios({
          method: "post",
          data: param,
          url,
        })
          .then((res) => {
            console.log("预付款余额");
            console.log(res.data);
            if (res.data.resultCode == 1) {
              this.prepayBalance = Array.isArray(res.data.data)
                ? res.data.data.length
                  ? res.data.data[0].balance
                  : 0
                : (res.data.data && res.data.data.balance) || 0;
              console.log("this.prepayBalance");
              console.log(this.prepayBalance);
            } else {
              this.$alert(res.data.resultMsg, {
                center: true,
                showClose: false,
              });
            }
          })
          .catch((err) => {
            this.$alert(JSON.stringify(err), {
              center: true,
              showClose: false,
            });
          });
      }
    },
    payTypeChange(e) {
      console.log(e);
      if (e == 4 || e == 5) {
        //4钱包余额支付,5预付款支付
        this.storeBanlanceAndPrepayPayFirstStep(e);
      } else if (e == 6) {
        //微信支付
        this.initWxEwm();
      }
      this.wallatePayTips = {
        show: false,
        value: "",
      };
    },
    initWxEwm() {
      let { access_token } = this.userInfo;

      let url = createOderCode;
      let data = {
        access_token: access_token,
        id: this.$route.query.id,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          if (res.data.resultCode == 1) {
            console.log(res);
            this.QRCodeUrl = `${baseUrl}/qrcode/${res.data.data}`;
            console.log(this.QRCodeUrl);
          } else {
            this.$alert(res.data.resultMsg, {
              center: true,
              showClose: false,
            });
          }
        })
        .catch((err) => {
          this.$alert(JSON.stringify(err), {
            center: true,
            showClose: false,
          });
        });
    },
    storeBanlanceAndPrepayPayFirstStep(pay_type) {
      let { access_token } = this.userInfo;

      let url = payOrderUrl;
      let data = {
        access_token: access_token,
        orderIds: this.$route.query.id,
        pay_type,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          this.existStoreWallatePsw = true;
          if (res.data.resultCode == 1) {
            console.log(res);
          } else {
            let { resultCode } = res.data;
            if (resultCode == -10 || resultCode == -15) {
              console.log("余额不足");
            } else if (resultCode === -8 || resultCode === -9) {
              this.existStoreWallatePsw = false;
              this.doNotHaveStoreWallatePsw();
            } else {
              this.$alert(res.data.resultMsg, {
                center: true,
                showClose: false,
              });
            }
          }
        })
        .catch((err) => {
          this.$alert(JSON.stringify(err), {
            center: true,
            showClose: false,
          });
        });
    },
    checkAndGetStoreBanlance() {
      let { access_token, storeId } = this.userInfo;
      if (storeId) {
        let url = getStoreAccountUrl;
        let data = {
          access_token: access_token,
          store_id: storeId,
        };
        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        this.$axios({
          method: "post",
          data: param,
          url,
        })
          .then((res) => {
            if (res.data.resultCode == 1) {
              this.storeWalletBalance = res.data.data
                ? res.data.data.avl_balance
                : 0;
            } else {
              this.$alert(res.data.resultMsg, {
                center: true,
                showClose: false,
              });
            }
          })
          .catch((err) => {
            this.$alert(JSON.stringify(err), {
              center: true,
              showClose: false,
            });
          });
      }
    },
    doNotHaveStoreWallatePsw() {
      this.$alert("您尚未设置预付款支付密码，请设置后再支付", "提示");
    },
    cutDown() {
      let time = this.time;
      this.sendMsgDisabled = true;
      this.msg = time + "s";

      let timer = setInterval(() => {
        if (time > 1) {
          time--;
          this.time = time;
          this.msg = time + "s";
        } else {
          clearInterval(this.timer);
          this.sendMsgDisabled = false;
          this.msg = "验证码";
        }
      }, 1000);
    },
    sendPayMessage() {
      //  id,
      //   access_token,
      //   orderId,
      //   mobile_id,
      //   type: 2

      this.sendButtonLoading = true;
      this.msg = "发送中";
      let url = sendPayVerifyCodeUrl;
      let { id, mobile_id } = this.bank;
      let data = {
        access_token: this.userInfo.access_token,
        type: 2,
        id,
        mobile_id,
        orderId: this.$route.query.id,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            this.sendButtonLoading = false;
            this.msg = "验证码";
            this.cutDown();
          } else {
            this.sendButtonLoading = false;
            this.msg = "验证码";
            this.$alert(res.data.resultMsg);
          }
        })
        .catch((err) => {
          this.sendButtonLoading = false;
          this.msg = "验证码";
          alert(err.msg);
        });
    },
    selectBank(item, index) {
      let bankList = JSON.parse(JSON.stringify(this.bankList));
      bankList.forEach((item) => {
        item.checked = false;
      });
      bankList[index].checked = true;

      this.bankList = bankList;
      this.bank = item;
    },
    passwardChanage(e) {
      console.log(e);
      if (e.toString().length == 6) {
        //判断当前支付方式下余额是否充足

        if (this.checkBalanceIsEnough()) {
          this.storeBanlanceAndPrepayPaySecondStep(e);
        } else {
          this.wallatePayTips = {
            show: true,
            value: "可用余额不足",
          };
        }
      }
    },

    checkBalanceIsEnough() {
      let payType = this.payType;
      let { totalMoney } = this.$route.query;
      if (payType == 4) {
        return this.storeWalletBalance >= totalMoney;
      } else if (payType == 5) {
        return this.prepayBalance >= totalMoney;
      }
    },

    storeBanlanceAndPrepayPaySecondStep(e) {
      let { access_token } = this.userInfo;

      let url = balancePayUrl;
      let data = {
        access_token,
        pay_type: this.payType,
        payPwd: this.$md5(e+""),
        order_id: this.$route.query.id,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          if (res.data.resultCode == 1) {
            this.$alert(`支付成功`, { center: true, showClose: false }).then(
              () => {
                this.$router.replace("myOrder");
              }
            );
          } else {
            let wallatePayTips = JSON.parse(
              JSON.stringify(this.wallatePayTips)
            );
            wallatePayTips.show = true;
            wallatePayTips.value = res.data.resultMsg;
            this.wallatePayTips = wallatePayTips;
          }
        })
        .catch((err) => {
          this.$alert(JSON.stringify(err), {
            center: true,
            showClose: false,
          });
        });
    },
    getBankList() {
      let url = listBankCardUrl;
      let data = {
        access_token: this.userInfo.access_token,
        type: 2,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            let bankList = res.data.data;
            if (bankList && bankList.length) {
              bankList[0].checked = true;
            }
            this.bankList = bankList;

            this.bank = bankList[0];
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch((err) => {
          this.$alert(JSON.stringify(err));
        });
    },
    recharge() {
      // id,
      //     access_token,
      //     orderId,
      //     type: 2,
      //     mobile_id,
      //     verify_code
      if (!this.code) {
        return this.$alert("验证码不能为空");
      }
      this.payMsg = "支付中...";
      let url = confirmPayVerifyUrl;
      let { id, mobile_id } = this.bank;
      let data = {
        access_token: this.userInfo.access_token,
        type: 2,
        id,
        mobile_id,
        orderId: this.$route.query.id,
        verify_code: this.code,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            this.payMsg = "确认支付";
            // this.$alert("支付成功");
            // this.$emit('paySuccess')
            this.$alert(`支付成功`, { center: true, showClose: false }).then(
              () => {
                this.$router.go(-1);
              }
            );
            //  let waitingTime = this.waitingTime
            //  let timer2= setInterval(()=>{
            //    if(waitingTime>1){
            //      waitingTime--
            //      this.waitingTime = waitingTime
            //    }else{
            //      clearInterval(timer2)
            //      this.$router.push("myOrder")
            //    }
            //   },1000)
          } else {
            this.payMsg = "确认支付";
            this.$alert(res.data.resultMsg);
          }
        })
        .catch((err) => {
          this.payMsg = "确认支付";
          alert(err.msg);
        });
    },
  },
};
</script>

<style scoped lang="less">
// @import '../style/mixin';
.payPage {
  font-size: 14px;
}
.payPageBox {
  padding: 20px 150px;
  min-width: 1000px;
  min-height: 600px;
}
.orderInfo {
  width: 100%;
  margin-top: 10px;
  height: 60px;
  // background-color:pink;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.orderInfoUp,
.orderInfoDown {
  display: flex;
  justify-content: space-between;
  width: 100%;
  // background-color: blue;
}
.yhk {
  display: flex;
  align-items: center;
}
.yhkBox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px 10px;
}
.yhkNum {
  width: 400px;
  padding: 5px;
  border: 2px solid #fff;
  margin: 10px 0;
}
.yhkNum:hover {
  border: 2px solid #cad6ef;
  cursor: pointer;
}
.checked:hover {
  border: 2px solid #85a1d4;
  color: rgb(82, 131, 180);
}
.checked {
  border: 2px solid #f70;
  background-color: #ff98001c;
}
.yhkMore {
  margin-left: 20px;
}
.totalMoney {
  color: #f40;
  font-size: 16px;
  font-weight: 700;
}
.pay {
  margin: 20px 0;
}
.payTitle {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  height: 50px;
  line-height: 50px;
}
.sendMsgBox {
  display: flex;
  align-items: center;
}
.sendMsgBoxInput {
  width: 100px;
}
.phoneNumber {
  margin: 30px 0 10px 0;
  font-size: 13px;
  color: #454545;
}
.inputPsw {
  margin: 20px 0 10px 0;
  font-size: 14px;
  color: #666;
}
.addNewCard {
  margin: 10px 0;
}
.recharge {
  margin: 30px 0;
}
.lackTips {
  color: #f40;
  font-size: 14px;
}
.wallatBalanceBoxInput {
  width: 150px;
}
.wallatePayTips {
  margin-left: 10px;
  color: #f40;
  font-size: 14px;
}
.wxGoback {
  text-decoration: underline;
  margin-left: 5px;
}
.wxGoback:hover {
  cursor: pointer;
}
.setPwdBox {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/PayPage.vue